import "./index.css"
import Header from "../header"
import CRMPage from "../crm"
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    
  const navigate = useNavigate();

  useEffect(() => {
    const loggedIn = Cookies.get('ddabroad_google_email');
    console.log(loggedIn)
    console.log("in dashboard")

    if (!loggedIn) {
      navigate('/login');
    }
  }, [navigate]);
    


    return (
        <>
          <Header />
          <CRMPage />
        </>
    )

}

export default Dashboard